import { Grid, Typography } from "@mui/material";
import ArrowRightOutlinedIcon from "@mui/icons-material/ArrowRightOutlined";
import React from "react";

const SpeakWithCoachQuestions = ({
  speakWithCoachQuestions,
}: {
  speakWithCoachQuestions: string;
}): React.JSX.Element => (
  <React.Fragment>
    <Typography variant="h6" color="initial" sx={{ mb: 1 }}>
      Über folgenden Themen konnte ich mit dem Coach sprechen:
    </Typography>

    {speakWithCoachQuestions === "" ? (
      <Typography variant="body1" color="initial">
        keine Angabe
      </Typography>
    ) : (
      <Grid container spacing={1}>
        {speakWithCoachQuestions.split(",").map((topic) => {
          if (topic === "") return null;
          return (
            <Grid item xs={12} sm={6} md={4} key={topic}>
              <Typography
                variant="body1"
                color="initial"
                sx={{
                  display: "flex",
                  alignItems: "top",
                  justifyContent: "left",
                }}
              >
                <ArrowRightOutlinedIcon
                  sx={{
                    mr: 1,
                    color: (theme) => theme.palette.primary.main,
                  }}
                />{" "}
                {topic}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    )}
  </React.Fragment>
);

export default SpeakWithCoachQuestions;
